import api from './api';

export const userService = {
  async getDirectReports(managerId) {
    const response = await api.get(`/users/${managerId}/direct-reports`);
    return response.data;
  },

  async getCurrentUser() {
    const response = await api.get('/users/me');
    return response.data;
  },

  async getAllUsers() {
    const response = await api.get('/users');
    return response.data;
  }
};
